// src/components/ChargingStation/CheckoutSection.tsx
import React, {useEffect, useState} from 'react';
import { View, Text, Pressable, StyleSheet, Platform } from 'react-native';
import { AntDesign } from '@expo/vector-icons';
import LoadingButton from '../LoadingButton';
import * as Haptics from 'expo-haptics';
import TooltipModal from '../TooltipModal';
import { tooltips, buildProcessingFeesTooltip, Tooltip_t } from '../common/tooltips/tooltips';
import RoleService from '../../services/role-service';

interface CheckoutSectionProps {
  selectedChargerIsFree: boolean;
  activeCharges: any;
  order: any;
  sessionRole: string | string[] | undefined;
  scheduleSet: boolean;
  paymentData: any;
  isValidEmail: boolean;
  handleCheckoutButton: () => Promise<void>;
  handleOpenPaymentSheet: () => Promise<void>;
  showFeeTooltipVisible: boolean;
  showFeeTooltip: () => void;
  hideFeeTooltip: () => void;
}

const CheckoutSection: React.FC<CheckoutSectionProps> = ({
  selectedChargerIsFree,
  activeCharges,
  order,
  sessionRole,
  scheduleSet,
  paymentData,
  isValidEmail,
  handleCheckoutButton,
  handleOpenPaymentSheet,
  showFeeTooltipVisible,
  showFeeTooltip,
  hideFeeTooltip,
}) => {
  if (selectedChargerIsFree || activeCharges || !order) {
    return null;
  }

  const [processingFeesTooltip, setProcessingFeesTooltip] = useState<Tooltip_t>(tooltips.processingFees);

  useEffect(() => {
    if (order?.id) {
      setProcessingFeesTooltip(buildProcessingFeesTooltip(order));
    }
  }, [order?.id]);

  return (
    <View style={styles.BgColor4} className="p-6">
      <Text className="text-base font-bold text-center text-slate-100">
        Complete checking out this charger
      </Text>
      <Text className="text-base font-normal text-center text-slate-100">
        By pressing "Check Out Charger" you agree to this charger's hourly rate
        above, plus applicable fees.{' '}
        <AntDesign
          onPress={showFeeTooltip}
          name="questioncircle"
          size={16}
          color="#fff"
          style={styles.tooltip}
        />
      </Text>
      <View style={{ marginTop: 10 }}>
        {Platform.OS === 'web' ? (
          <LoadingButton
            onPress={handleCheckoutButton}
            disabled={
              Platform.OS === 'web'
                ? !paymentData || (RoleService.parseUserRoles(sessionRole).includes('guest') && !isValidEmail)
                : false
            }
          >
            Complete Checkout
          </LoadingButton>
        ) : (
          <LoadingButton 
            onPress={async () => { 
              try { await Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success); } 
              catch {} 
              await handleOpenPaymentSheet(); 
            }}
            disabled={!isValidEmail && RoleService.parseUserRoles(sessionRole).includes("guest")}
          >
            Pay and Checkout
          </LoadingButton>
        )}
      </View>

      <TooltipModal
        tooltipData={processingFeesTooltip}
        visible={showFeeTooltipVisible}
        onClose={hideFeeTooltip}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  BgColor4: {
    backgroundColor: '#003547',
  },
  tooltip: {
    marginLeft: 8,
  },
});

export default CheckoutSection;
